import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_WORKSTREAM_BY_ID_PATH,
  GetOrganizationWorkstreamByIdErrorDto,
  GetOrganizationWorkstreamByIdRequestPathVariables,
  GetOrganizationWorkstreamByIdSuccessDto,
} from '@/api/rest/resources/types/workstreams';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetOrganizationWorkstreamByIdSuccessDto;
type ErrorDto = GetOrganizationWorkstreamByIdErrorDto;

export const useOrganizationWorkstream = (workstreamIdArg?: string, organizationIdArg?: string) => {
  const orgId = useOrganizationId();
  const wsId = useWorkstreamId();

  const organizationId = organizationIdArg ?? orgId;
  const workstreamId = workstreamIdArg ?? wsId;

  assertIsDefined(organizationId, 'organizationId');
  assertIsDefined(workstreamId, 'workstreamId');

  const pathVariables: GetOrganizationWorkstreamByIdRequestPathVariables = {
    organization_id: organizationId,
    workstream_id: workstreamId,
  };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_WORKSTREAM_BY_ID_PATH, pathVariables);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', organizationId, 'workstreams', workstreamId],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
